// extracted by mini-css-extract-plugin
export default {"criteriaGroup":"criteriaGroup_criteriaGroup__dtRxw","criteriaGroupName":"criteriaGroup_criteriaGroupName__td8a7","selectCurrency":"criteriaGroup_selectCurrency__9Bvy0"};